export default __webpack_public_path__ + "static/media/3bae5e6f942756fb7e37a80cda1fae53.md";